import { NgModule } from '@angular/core';

import { DashboardComponent } from './dashboard.component';
import { FormsModule } from '@angular/forms';
import { UsersService } from '../services/users.service';
import { RouterModule } from '@angular/router';
import { LastMsgrComponent } from './last-msgr/last-msgr.component';
import { MyBookingsComponent } from './my-bookings/my-bookings.component';
import { MomentModule } from 'ngx-moment';
import { MyConvocationsComponent } from './my-convocations/my-convocations/my-convocations.component';
import { PluginGoogleCalendarModule } from '../plugin-google-calendar/plugin-google-calendar.module';
import { ShortcutsBarComponent } from './shortcuts-bar/shortcuts-bar.component';
import { SqrsBroadcastComponent } from './sqrs-broadcast/sqrs-broadcast.component';
import { ActiveAnnouncesBannerComponent } from './active-announces-banner/active-announces-banner.component';
import { MyAppointmentsComponent } from './my-appointments/my-appointments.component';
import { SdisActivityComponent } from './sdis-activity/sdis-activity.component';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DidYouKnowComponent } from './did-you-know/did-you-know.component';
import { TodayEventsBannerComponent } from './today-events-banner/today-events-banner.component';

@NgModule({
  declarations: [
    DashboardComponent,
    LastMsgrComponent,
    MyBookingsComponent,
    MyConvocationsComponent,
    ShortcutsBarComponent,
    SqrsBroadcastComponent,
    ActiveAnnouncesBannerComponent,
    MyAppointmentsComponent,
    SdisActivityComponent,
    DidYouKnowComponent,
    TodayEventsBannerComponent,
  ],
  imports: [
    CommonModule,
    MomentModule,
    FormsModule,
    RouterModule,
    PluginGoogleCalendarModule,
    ModalModule,
    TooltipModule,
    SharedModule,
  ],
  exports: [DashboardComponent, SqrsBroadcastComponent],
  providers: [UsersService],
})
export class DashboardsModule {}
